// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__107tm","col":"Table_col__kec3n","fulfillmentStatus":"Table_fulfillmentStatus__16Cto","emailCol":"Table_emailCol__2oJqN"};